// FieldTargetTypeField.jsx

import React from 'react';

// Components
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';
import SelectInput from 'components/selectinput/SelectInput';

/**
 * FieldTargetTypeField
 *
 * Renders the node type selector for nodelist form fields.
 *
 * @param {string} draftTargetType - The currently selected target node type key.
 * @param {object[]} targetTypeOptions - Available node type options.
 * @param {object} theme - Active theme values.
 * @param {string} error - Validation message for the field.
 * @param {boolean} disabled - Whether the select is disabled.
 * @param {function} onTargetTypeChange - Called when the selected node type changes.
 *
 * @returns {ReactNode} The rendered node type selector.
 */
const FieldTargetTypeField = ({
    draftTargetType,
    targetTypeOptions,
    theme,
    error,
    disabled,
    onTargetTypeChange,
}) => {

  // ----- RENDER ----- //

  return (

    <ModalField>

        <ModalLabel label="Database" />
        <ModalHint hint="Choose the database whose records populate this field." />

        <SelectInput
          style={{
            width: '100%',
          }}
          value={draftTargetType}
          options={targetTypeOptions}
          placeholder="Select a node type"
          disabled={disabled}
          error={!!error}
          helperText={error}
          onValueChange={(value) => onTargetTypeChange(value)}
        />

    </ModalField>

);
};

// Dev Tools
FieldTargetTypeField.displayName = 'FieldTargetTypeField';

export default FieldTargetTypeField;
